/**
 * 资产管理
 */
import http from '@/http'

export default {
  // TPM 点检数据统计
  getTPM(params) {
    return http.get('/home/statistic/tpm', {params})
  },
  // 指定日期资产类型点检统计，未传日期时统计今日
  getAssetTypeTpmStatistics(params) {
    return http.get('/home/statistic/asset-type-tpm', { params })
  },
  // 指定日期的点检任务汇总（任务维度），未传日期时统计今日
  getTpmTaskSummary(params) {
    return http.get('/home/statistic/tpm-task-summary', { params })
  },
  getAssetTypeTpmDetail(params) {
    return http.get('/home/statistic/asset-type-tpm-detail', { params })
  },
  // 指定工段的点检下钻：该工段各资产类型与下属各班组的点检统计
  getWorkStationTpmDetail(params) {
    return http.get('/home/statistic/work-station-tpm-detail', { params })
  },
  // 资产数据统计
  getStatistics() {
    return http.get('/home/statistic/asset')
  },
  // 各工段资产数量统计
  getWorkStationAssetStatistics(params) {
    return http.get('/home/statistic/work-station-asset', { params })
  },
  // 各工段工具寿命统计（正常 / 预警），含工段下的班组明细
  getWorkStationToolLifeStatistics() {
    return http.get('/home/statistic/work-station-tool-life')
  },
  // 首页最近点检记录
  getRecentTpmRecords(params) {
    return http.get('/home/record/recent', { params })
  },
  // 首页实时未点检任务（按工位维度，分页）
  getPendingStationTasks(params) {
    return http.get('/home/pending-station-tasks', { params })
  },
  // 报警统计
  getWarnStatistics(params) {
    return http.get('/home/statistic/warn', {params})
  },
  // 首页待处理的寿命预警
  getWarnMsg(params) {
    return http.get('/home/message/warn', {params})
  },
  // 寿命预警详情（参数为预警消息 id）
  getWarnMsgDetail(id) {
    return http.get(`/home/message/warn/${id}`)
  },
  // 标记寿命预警为已处理
  signHasBeenRead(params) {
    return http.post('/home/message/read', params)
  }
}
